import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Loader2, Mail, Send, X } from "lucide-react";
import { apiPost } from "@/lib/api";

export const ConsumMultipluBar = ({ bifate, onClear, onSent }) => {
  const [sending, setSending] = useState(false);
  if (bifate.length === 0) return null;
  const send = async () => {
    setSending(true);
    try {
      const r = await apiPost("/comenzi/consum-email-multiplu", { ids: bifate.map((c) => c.id) });
      toast.success(`Trimis catre ${r.to} (CC ${r.cc}): ${r.nr_comenzi} comenzi`);
      onSent(bifate.map((c) => c.id), r);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSending(false);
    }
  };
  return (
    <div
      className="sticky top-2 z-20 mb-3 flex flex-wrap items-center gap-3 rounded-lg border border-amber-300 bg-amber-50 p-3 shadow-sm"
      data-testid="consum-multiplu-bar"
    >
      <span className="text-sm font-medium text-slate-800" data-testid="consum-multiplu-count">
        {bifate.length} {bifate.length === 1 ? "comanda bifata" : "comenzi bifate"}:
        <span className="ml-1 text-slate-500 tabular-nums">{bifate.map((c) => c.com_erp).join(", ")}</span>
      </span>
      <div className="ml-auto flex gap-2">
        <Button variant="outline" size="sm" onClick={onClear} disabled={sending} data-testid="consum-multiplu-clear">
          <X className="h-4 w-4 mr-1" />Debifeaza
        </Button>
        <Button
          size="sm"
          onClick={send}
          disabled={sending}
          className="bg-slate-900 hover:bg-slate-800 text-white"
          data-testid="consum-multiplu-send"
        >
          <Mail className="h-4 w-4 mr-1 text-amber-400" />Trimite la Corina (un singur mail)
          {sending ? <Loader2 className="h-4 w-4 ml-2 animate-spin" /> : <Send className="h-4 w-4 ml-2" />}
        </Button>
      </div>
    </div>
  );
};
